import { Pipe, PipeTransform } from '@angular/core';
import {CommonFunctions} from '../utils/common-functions';
import {PERIOD_TYPES_STRING} from '../utils/constants';

@Pipe({
    name: 'dateToPeriod',
    standalone: false
})
export class DateToPeriodPipe implements PipeTransform {
  /**
   *
   * @param {string} value
   * @returns {string}
   */
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return PERIOD_TYPES_STRING[CommonFunctions.getPeriodTypeAsString(value)];
  }
}
